import { useSyncExternalStore } from "react";
import { resolveUnits, storedUnitsChoice, subscribeUnitsChoice, type Units, type UnitsChoice } from "./units";

/** The account page's units choice in this browser, kept current across tabs. */
export function useUnitsChoice(): UnitsChoice {
  return useSyncExternalStore(subscribeUnitsChoice, storedUnitsChoice);
}

/** The units to show distances and speeds in. */
export function useUnits(): Units {
  return resolveUnits(useUnitsChoice());
}
